<template>
    <div class="avatar-root normal">
        <b-img
            v-if="image"
            class="w-100 h-100 image"
            :src="image + '/small.jpg'"
            :class="{ large: size === 'large' }"
            rounded="circle"
        />
        <div
            v-else
            class="avatar-base noselect"
            :class="[{ large: size === 'large' }, { huge: size === 'huge' }]"
        >
            <slot />
        </div>
        <div v-if="hasFooterSlot" class="badge">
            <slot name="badge" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        image: String,
        size: String,
    },
    computed: {
        hasFooterSlot() {
            return !!this.$slots['badge'];
        },
    },
};
</script>

<style scoped>
.avatar-root {
    position: relative;
}
.avatar-base {
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    font-size: 1.25rem;

    background-color: #bdbdbd;
    color: white;

    width: 100%;
    height: 100%;
}

.normal {
    width: 40px;
    height: 40px;
}
.large {
    width: 60px;
    height: 60px;
}

.huge {
    font-size: 2.8rem;
    width: 140px !important;
    height: 140px !important;
}

.badge {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
}
.image {
    object-fit: cover;
}
</style>
